<template>
<div class="smart-form">
  <div class="smart-icon">
      <img src="../assets/bahn.png" width="120px"/>
     </div>
    <div class="screentime-hl">Welcher Bahnhof kostet Sie keine Nerven?</div>
    
  <div class="screentime-form">
      <form v-if="hasQuizForm"> 
        <br>
           <div class="inner-form">
         <button class="gen_button" v-on:click.prevent="generateOption1">Kassel-Wilhemshöhe</button>
          &nbsp;&nbsp;
         <button class="gen_button" v-on:click.prevent="generateOption2">Nürnberg</button>
          &nbsp;&nbsp;
         <button class="gen_button" v-on:click.prevent="generateOption3">Frankfurt am Main</button>
<br>
 <br>
</div></form>
  </div>
  <div v-if="hasChoosen" class="smartphone-dataviz">
  <br>
         <div class="screentime-description" v-html="quizDescription"> <br><br>
        </div>
    <br><br>
   <div class="dataviz-source"> Quelle: Deutsche Bahn</div>
  </div>
  </div>
</template>


<script>
export default {
  name: 'Quiz',
  props: {
    
  },
  data() {
        return {
            optionChoosen: "",
            hasChoosen: false,
            hasQuizForm:true       }     
    },
    computed: {
       
         quizDescription: function () {
        let smartAppMsg="";
            if (this.optionChoosen == "Option1") {
                smartAppMsg= "Sie haben den Bahnhof Kassel-Wilhelmshöhe gewählt. Das ist leider falsch! Der Bahnhof Kassel-Wilhelmshöhe belegt im Ranking den letzten Platz. Der passagierfreundlichste Bahnhof ist der Nürnberger Bahnhof. Neben dem Nürnberger Hauptbahnhof konnten auch der Hannover Hauptbahnhof und der Leipziger Hauptbahnhof überzeugen. Berlin landete nur auf Rang 21."
            }
            if (this.optionChoosen == "Option2") {
                smartAppMsg= "Sie haben den Nürnberger Bahnhof gewählt. Richtig!  Der Nürnberger Hauptbahnhof ist der passagierfreundlichste Bahnhof Deutschlands. Daneben konnten auch der Hannover Hauptbahnhof und der Leipziger Hauptbahnhof überzeugen. Berlin landete nur auf Rang 21. Kassel Wilhemshöhe landete auf dem letzten Platz."
            }
            if (this.optionChoosen == "Option3") {
                smartAppMsg= "Sie haben den Bahnhof Frankfurt am Main gewählt. Damit liegen Sie leider daneben! Der Frankfurter Bahnhof belegt den vorletzten Platz im Ranking. Der passagierfreundlichste Bahnhof ist der Nürnberger Bahnhof. Neben dem Nürnberger Hauptbahnhof konnten auch der Hannover Hauptbahnhof und der Leipziger Hauptbahnhof überzeugen. Berlin landete nur auf Rang 21."
            }
                        
            return (smartAppMsg)
            }
            
       

    },
  methods: {
        generateOption1: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "Option1";
           
           }  
        },
         generateOption2: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "Option2";
           
           }  
        },
         generateOption3: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "Option3";
           
           }  
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../assets/styles.css';
</style>
